import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { requestChatTransfer } from '@src/reducers/chats/chatTransfer';
import { fetchUsers } from '@src/reducers/users';
import { activeChatSelector } from '@src/selectors/chats';
import { getMerchantId, userLogged } from '@src/selectors/user';
import { RootState } from '@src/store/reduxstore';
import { ChatTrayXfer } from '@src/types/chats';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ChatTransferAgentsPicker from './ChatTransferAgentsPicker2';

const TransferDialogWrapper: React.FC<{
  onCancel: () => void;
  onTransfer: () => void;
}> = ({ onTransfer, onCancel }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;

  const activeChat = useSelector((state: RootState) =>
    activeChatSelector(state)
  );
  const merchantId = useSelector(getMerchantId);
  const userId = useSelector(userLogged).id;
  const { departmentsState } = useSelector(
    ({ generalProperties }: RootState) => generalProperties
  );
  const areThereAgentsWithoutDepartment = useSelector((state: RootState) =>
    state.users.items.some(user => user.departments.length === 0)
  );

  return (
    <Dialog open maxWidth="lg">
      <DialogTitle>
        {formatMessage({ id: 'ChatTransfer.agentsPickerRequestDialogTitle' })}
      </DialogTitle>
      <DialogContent>
        <ChatTransferAgentsPicker
          activeChat={activeChat}
          merchantId={merchantId}
          userId={userId}
          departmentsState={departmentsState}
          onRequestAgentChatTransfer={(transfer: ChatTrayXfer) => {
            dispatch(requestChatTransfer(transfer));
            onTransfer();
          }}
          fetchUsers={() => dispatch(fetchUsers)}
          areThereAgentsWithoutDepartment={areThereAgentsWithoutDepartment}
          onCancel={onCancel}
        />
      </DialogContent>
    </Dialog>
  );
};

export default TransferDialogWrapper;
